import React from 'react';

import colors from '@front/common/src/utils/colors';
import { formatPercentage, formatPrice, formatPricePerMonth } from '@front/common/src/utils/formatting';

import { translate } from '@front/i18n';

import Text from '@front/web-ui/src/components/base-text/variants/text';
import TextButton from '@front/web-ui/src/components/button/text-button';

const t = translate('basket.membership.card');

type NoMembershipYetProps = {
  getMoreInfoPress: () => void;
  hasPrestationsSelected: boolean;
  reduction: number;
  membershipReductionsPercentage: number;
  membershipPrice: number;
};

const NoMembershipYet = ({
  getMoreInfoPress,
  reduction,
  hasPrestationsSelected,
  membershipReductionsPercentage,
  membershipPrice,
}: NoMembershipYetProps) => (
  <span>
    <Text.SMBold>{`${t('.wellness.is_not_yet_member.text_1')} `}</Text.SMBold>
    <Text.SMBold color={colors.pink120}>
      {` ${hasPrestationsSelected ? formatPrice(reduction) : formatPercentage(membershipReductionsPercentage)} `}
    </Text.SMBold>
    <Text.SMBold>{t('.wellness.is_not_yet_member.text_2')}</Text.SMBold>
    <Text.SM>{` ${t('.wellness.is_not_yet_member.text_3', { pricePerMonth: formatPricePerMonth(membershipPrice) })} `}</Text.SM>
    <TextButton size='sm' onClick={getMoreInfoPress}>
      {t('base.learn_more')}
    </TextButton>
  </span>
);

export default NoMembershipYet;
